<template>
  <div class="col-lg-6 mb-2 mb-xl-4">
    <router-link class="card text-reset text-decoration-none _hover h-100 " :to="RedirectTo">
      <div class="media p-3">
        <i
          class="course-img mr-3 _lg rounded-circle"
          :style="{ backgroundImage: `url('${Book.bookIcon}')` }"
        ></i>
        <div class="media-body align-self-center d-flex flex-column">
          <h6 class="f-xl-20">{{ Book.bookName }}</h6>
          <p class="mb-0 small text-secondary">{{ Book.groupName }}</p>
        </div>
      </div>
    </router-link>
  </div>
</template>
<script>
export default {
  name: 'Trail',

  props: {
    Book: Object,
    RedirectTo: String,
  },
};
</script>
